.root {
  display: inline-flex;
  align-items: center;
  column-gap: var(--spacing-ds-1-5);
}

.anchor {
  display: inline-flex;
  position: relative;
  flex-shrink: var(--flex-ds-shrink-none);
}

.trigger {
  display: inline-flex;
  align-items: center;
  border-radius: var(--radius-ds-pill);
  padding: var(--spacing-ds-0);
}

.positioner {
  position: absolute;
  top: var(--position-ds-full);
  left: var(--position-ds-half);
  translate: var(--translate-ds-center);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: var(--spacing-ds-1);
  width: var(--width-ds-max-content);
  max-width: var(--max-width-ds-viewport-inset);
  z-index: var(--z-index-ds-dropdown);
}

.panel {
  width: var(--width-ds-tooltip);
  max-width: var(--max-width-ds-tooltip);
  padding-inline: var(--spacing-ds-3);
  padding-block: var(--spacing-ds-2);
  border-radius: var(--radius-ds-control);
  font-size: var(--text-ds-caption);
  line-height: var(--line-height-ds-relaxed);
}

@media (width >= 640px) {
  .positioner {
    left: var(--translate-ds-none);
    translate: var(--translate-ds-none);
    align-items: flex-start;
    max-width: var(--max-width-ds-unbounded);
  }

  .panel {
    width: var(--width-ds-tooltip-wide);
    max-width: var(--max-width-ds-unbounded);
  }
}
